import { apiInstance } from '@api/client';
import { SearchListingQueryParams } from '@utils/types/searchListingsQueryParams';
import { SearchListingsResponse } from '@utils/types/searchListings';

export async function searchListingsRequest(
  qParams?: SearchListingQueryParams
): Promise<SearchListingsResponse> {
  const res = await apiInstance.get('/v1/listings', { params: qParams });
  return res.data;
}
